export default "__VITE_ASSET__BqNcmt9O__"